import gql from 'graphql-tag';
const MUSICIANS_ON_STAGE_ACTIVITY_FRAGMENT = gql `
  fragment MusiciansOnStageActivityFragment on MusiciansOnStageActivity {
    rounds {
      roundIndex
      audio
      musicians {
        img
        name
      }
      primary {
        img
        color
      }
      steps {
        stepIndex
        answer
      }
    }
  }
`;
export default MUSICIANS_ON_STAGE_ACTIVITY_FRAGMENT;
